import React, { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import LoadingBar from 'react-top-loading-bar';

const ScrollLoadingBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
 const handleScrollRef = useRef(
    throttle(() => {
      const windowHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight - windowHeight;
      const currentScroll = window.scrollY;

      const progress = (currentScroll / scrollHeight) * 100;
      setScrollProgress(progress);
    }, 100)
  );

  useEffect(() => {
    const handleScroll = handleScrollRef.current;

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel(); // cancel any pending throttled calls
    };
  }, []); // no dependencies needed

  return  <LoadingBar
  progress={scrollProgress}
  color="#000000" // Change the color to your desired color
  height={2} // Change the height to your desired height in pixels
/>;
};

export default ScrollLoadingBar;